class MFooter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordionContainer = this.querySelector(".m-footer--accordion");
    this.stickyBar = document.querySelector(".m-mobile-sticky-bar");

    this.handleMatchMobileForAccordion = this.handleMatchMobileForAccordion.bind(this);
    this.updateStickyBarHeight = this.updateStickyBarHeight.bind(this);

    if (this.accordionContainer) {
      if (window.MinimogTheme && MinimogTheme.config.mqlMobile) {
        this.initAccordion();
      }
      document.addEventListener("matchMobile", this.handleMatchMobileForAccordion);
    }

    if (this.stickyBar) {
      this.updateStickyBarHeight();
      document.addEventListener("matchMobile", this.updateStickyBarHeight);
      document.addEventListener("unmatchMobile", this.updateStickyBarHeight);
    }
  }

  disconnectedCallback() {
    if (this.accordionContainer) {
      document.removeEventListener("matchMobile", this.handleMatchMobileForAccordion);
    }
    if (this.stickyBar) {
      document.removeEventListener("matchMobile", this.updateStickyBarHeight);
      document.removeEventListener("unmatchMobile", this.updateStickyBarHeight);
    }
  }

  initAccordion() {
    if (window.MinimogLibs && MinimogLibs.Accordion) {
      this.acc = new MinimogLibs.Accordion(this.accordionContainer, {
        presetContentHeight: !0,
        onload: !0
      });
    }
  }

  handleMatchMobileForAccordion() {
    this.initAccordion();
  }

  updateStickyBarHeight() {
    if (this.stickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${this.stickyBar.offsetHeight}px`);
    }
  }
}
customElements.define("m-footer", MFooter);
